// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sx-2";
export var chatLink = "_sx-0";
export var chatText = "_sx-1";